export const AgWorksCoverageProcessingStatuses = {
  APPROVED: 'Approved',
  INCOMPLETE: 'Incomplete',
  PENDING: 'Pending',
} as const;

export type AgWorksCoverageProcessingStatus =
  (typeof AgWorksCoverageProcessingStatuses)[keyof typeof AgWorksCoverageProcessingStatuses];

/**
 * @note The processing statuses for LRP SCE (Specific Coverage Endorsements) are as follows:
 * - Incomplete: This is the initial status of a detail line. It remains "Incomplete" until the LRP SCE Signature Dates are added. Signature dates can be added either through the AgWorks System (AW System) user interface or via the SignEndorsements Livestock API+ call.
 * - Complete: Once the signature dates are added and all the information for the detail line is valid, the processing status updates to "Complete".
 * - Approved: The status becomes "Approved" after the RMA (Risk Management Agency) approves the endorsement/detail line.
 */

export const AgWorksEndorsementProcessingStatuses = {
  APPROVED: 'Approved',
  INCOMPLETE: 'Incomplete',
  COMPLETE: 'Complete',
} as const;

export type AgWorksEndorsementProcessingStatus =
  (typeof AgWorksEndorsementProcessingStatuses)[keyof typeof AgWorksEndorsementProcessingStatuses];

export const AgWorksCoverageStatuses = {
  NEW: 'New',
  TRANSFER_IN: 'Transfer In',
  INTERNAL_TRANSFER: 'Internal Transfer',
  RENEWAL: 'Renewal',
} as const;

export type AgWorksCoverageStatus =
  (typeof AgWorksCoverageStatuses)[keyof typeof AgWorksCoverageStatuses];
